/**
 * Search box for part number or description, used on the call-off grids
 * (CR-7717). Presentational: the caller owns the value and decides whether the
 * search runs client-side or is debounced to the server.
 */
import { Input } from '../../ui/input';
import { Search } from 'lucide-react';

interface PartSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  /** Sizing classes for the input (width, height). */
  className?: string;
  placeholder?: string;
}

export default function PartSearchInput({
  value, onChange, className = 'w-64', placeholder = 'Search part number or description…',
}: PartSearchInputProps) {
  return (
    <div className="relative">
      <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
      <Input
        type="search"
        className={`pl-8 ${className}`}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={placeholder}
      />
    </div>
  );
}
